module.exports = __webpack_public_path__ + "static/media/fasad11.fb4bd88d.jpeg";